"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFieldset = exports.StyledLegend = exports.StyledFormHelperText = exports.StyledFormControlLabelText = exports.StyledFormControlLabel = exports.StyledFormControl = exports.StyledForm = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helpers = require("../utils/helpers");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n      flex-direction: row;\n    "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n  border: none;\n  display: flex;\n  flex-direction: column;\n\n  ", ";\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n      margin-bottom: 0;\n    "]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  margin-bottom: 0.25rem;\n  margin-right: ", ";\n\n  ", ";\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  height: 1.55rem;\n  margin-bottom: -1.55rem;\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      margin-right: ", ";\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      flex-direction: row;\n      align-items: center;\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n\n  ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      width: 100%;\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      margin-bottom: ", ";\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      flex-direction: row;\n      align-items: baseline;\n      margin: 0 ", "\n        ", "\n        ", ";\n\n      ", " {\n        margin-left: ", ";\n      }\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin: 0 ", "\n    ", "\n    ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      flex-direction: row;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledForm = _styledComponents.default.form(_templateObject(), function (props) {
  return props.horizontal && (0, _styledComponents.css)(_templateObject2());
});

exports.StyledForm = StyledForm;

var StyledFormControl = _styledComponents.default.div(_templateObject3(), function (props) {
  return (0, _helpers.unitCalc)(props.theme.baseline, 4, '/');
}, function (props) {
  return (0, _helpers.unitCalc)(props.theme.baseline, 1.25, '*');
}, function (props) {
  return (0, _helpers.unitCalc)(props.theme.baseline, 4, '/');
}, function (props) {
  return props.horizontal && (0, _styledComponents.css)(_templateObject4(), function (props) {
    return (0, _helpers.unitCalc)(props.theme.baseline, 4, '/');
  }, function (props) {
    return (0, _helpers.unitCalc)(props.theme.baseline, 2, '/');
  }, function (props) {
    return (0, _helpers.unitCalc)(props.theme.baseline, 4, '/');
  }, StyledFormHelperText, function (props) {
    return (0, _helpers.unitCalc)(props.theme.baseline, 4, '/');
  });
}, function (props) {
  return props.noValidation && (0, _styledComponents.css)(_templateObject5(), function (props) {
    return (0, _helpers.unitCalc)(props.theme.baseline, 4, '/');
  });
}, function (props) {
  return props.fullWidth && (0, _styledComponents.css)(_templateObject6());
});

exports.StyledFormControl = StyledFormControl;

var StyledFormControlLabel = _styledComponents.default.label(_templateObject7(), function (props) {
  return props.horizontal && (0, _styledComponents.css)(_templateObject8());
});

exports.StyledFormControlLabel = StyledFormControlLabel;

var StyledFormControlLabelText = _styledComponents.default.span(_templateObject9(), function (props) {
  return props.horizontal && (0, _styledComponents.css)(_templateObject10(), function (props) {
    return (0, _helpers.unitCalc)(props.theme.baseline, 2, '/');
  });
});

exports.StyledFormControlLabelText = StyledFormControlLabelText;

var StyledFormHelperText = _styledComponents.default.span(_templateObject11(), (0, _helpers.fontSize)(-3), function (props) {
  return props.theme.palette.transparentBlack;
}, function (props) {
  return props.error && (0, _styledComponents.css)(_templateObject12(), function (props) {
    return props.theme.palette.darkRed200;
  });
}, function (props) {
  return props.success && (0, _styledComponents.css)(_templateObject13(), function (props) {
    return props.theme.palette.darkGreen200;
  });
});

exports.StyledFormHelperText = StyledFormHelperText;

var StyledLegend = _styledComponents.default.legend(_templateObject14(), function (props) {
  return (0, _helpers.unitCalc)(props.theme.baseline, 2, '/');
}, function (props) {
  return props.horizontal && (0, _styledComponents.css)(_templateObject15());
});

exports.StyledLegend = StyledLegend;

var StyledFieldset = _styledComponents.default.div(_templateObject16(), function (props) {
  return props.horizontal && (0, _styledComponents.css)(_templateObject17());
});

exports.StyledFieldset = StyledFieldset;


//////////////////
// WEBPACK FOOTER
// ./node_modules/calcite-react/Form/Form-styled.js
// module id = 150
// module chunks = 0